import styled from 'styled-components';

import { StackProps } from './types';
import { Alignments } from './Alignments';

import { theme } from '../../theme';

/**
 * Layout component.
 */
export const Stack = styled.div<StackProps>`
  display: flex;

  ${(props) => {
    const { direction = 'vertical', alignX = 'start', alignY = 'start', spacing = 'base' } = props;

    let alignItems;
    let justifyContent;
    let flexDirection;
    let itemFlex;
    let marginTop = '';
    let marginLeft = '';

    if (direction === 'vertical') {
      alignItems = alignX && Alignments[alignX];
      justifyContent = alignY && Alignments[alignY];
      marginTop = theme.sizes[spacing];
      flexDirection = 'column';
    } else {
      alignItems = alignY && Alignments[alignY];
      justifyContent = alignX && Alignments[alignX];
      marginLeft = theme.sizes[spacing];
      flexDirection = 'row';
    }

    // These options result in 'justify-content: stretch' which doesn't exist,
    // so instead we set the flex of child elements
    if (
      (direction === 'vertical' && alignY === 'stretch') ||
      (direction === 'horizontal' && alignX === 'stretch')
    ) {
      itemFlex = 1;
    }

    return `
      align-items: ${alignItems};
      justify-content: ${justifyContent};
      flex-direction: ${flexDirection};

      & > * {
        flex: ${itemFlex};
      }

      & > * + * {
        margin-top: ${marginTop};
        margin-left: ${marginLeft};
      }
    `;
  }}
`;

Stack.displayName = 'Stack';
